import React, { useState, useRef } from "react";
import "./ScoreCard.css";
import RateScorecardModal from "./RateScorecardModal";
import html2pdf from "html2pdf.js";
import { decoratePdf } from "../../utils/pdfDecoration";
import watermarkImage from "../../assets/images/logo/SVG/Logo-Org.svg";
import pdfHeaderLogo from "../../assets/images/pdfHeaderLogo.svg";

/* ─── SVG Icon Components ─── */

const RankIcon = () => (
  <svg width="24" height="24" viewBox="0 0 36 36" fill="none">
    <path d="M16.4883 3.05838C15.3492 5.3787 14.9906 6.06073 14.8781 6.08182C14.7937 6.10291 13.3875 6.30682 11.7422 6.53885C10.0969 6.77792 8.6625 6.98182 8.54297 7.00995C8.33906 7.0451 8.40234 7.11541 10.7437 9.41463L13.1555 11.7771L12.5859 15.0748C12.2766 16.8889 12.0305 18.3795 12.0375 18.3865C12.0516 18.4006 13.3734 17.7115 14.9766 16.8678C16.5797 16.024 17.9437 15.3279 18 15.3279C18.0562 15.3279 19.4203 16.024 21.0234 16.8678C22.6266 17.7115 23.9484 18.4006 23.9625 18.3865C23.9695 18.3795 23.7234 16.8889 23.4141 15.0748L22.8445 11.7771L25.2562 9.41463C27.5977 7.11541 27.6609 7.0451 27.457 7.00995C27.3375 6.98182 25.9031 6.77792 24.2578 6.53885C22.6125 6.30682 21.2062 6.10291 21.1219 6.08182C21.0094 6.06073 20.6508 5.3787 19.5117 3.05838C18.7031 1.41307 18.0211 0.0701027 18 0.0701027C17.9789 0.0701027 17.2969 1.41307 16.4883 3.05838Z" fill="#930AFF"/>
    <path d="M7.18587 20.9305L7.20697 23.9961L12.6351 26.1758L18.0632 28.3555L23.4281 26.1758L28.7929 23.9961L28.814 20.9305C28.821 19.2359 28.807 17.8578 28.7788 17.8578C28.7437 17.8578 26.3109 18.8281 23.3648 20.0094L17.9999 22.168L12.6351 20.0094C9.689 18.8281 7.25619 17.8578 7.22103 17.8578C7.19291 17.8578 7.17884 19.243 7.18587 20.9305Z" fill="#BA63FF"/>
    <path d="M7.17188 28.5469C7.17188 30.9445 7.19297 31.6336 7.26328 31.6617C7.30547 31.6828 9.75937 32.6672 12.7055 33.8484L18.0633 36L23.3578 33.8484C26.2687 32.6672 28.6945 31.6828 28.7437 31.6617C28.807 31.6336 28.8281 30.9445 28.8281 28.5469V25.4672L23.4141 27.6328L18 29.7984L12.5859 27.6328L7.17188 25.4672V28.5469Z" fill="#E1BBFF"/>
  </svg>
);

const CheckIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M7.5 10L9.16667 11.6667L12.5 8.33333M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10Z" stroke="#16a34a" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const TargetIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <circle cx="10" cy="10" r="7" stroke="#2563eb" strokeWidth="1.5"/>
    <circle cx="10" cy="10" r="3" stroke="#2563eb" strokeWidth="1.5"/>
    <line x1="10" y1="2" x2="10" y2="5" stroke="#2563eb" strokeWidth="1.5"/>
    <line x1="10" y1="15" x2="10" y2="18" stroke="#2563eb" strokeWidth="1.5"/>
    <line x1="2" y1="10" x2="5" y2="10" stroke="#2563eb" strokeWidth="1.5"/>
    <line x1="15" y1="10" x2="18" y2="10" stroke="#2563eb" strokeWidth="1.5"/>
  </svg>
);

const StarIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M10 2L12.09 7.26L17.5 7.64L13.18 11.42L14.54 16.77L10 13.97L5.46 16.77L6.82 11.42L2.5 7.64L7.91 7.26L10 2Z" fill="#eab308" stroke="#eab308" strokeWidth="1"/>
  </svg>
);

const AttemptCheckIcon = () => (
  <svg width="24" height="24" viewBox="0 0 56 56" fill="none">
    <rect x="0.5" y="0.5" width="55" height="55" rx="7.5" fill="#FFFBE5"/>
    <rect x="0.5" y="0.5" width="55" height="55" rx="7.5" stroke="#FFEC7E"/>
    <path d="M22.4 14.97C18.3 14.97 14.97 18.3 14.97 22.4C14.97 26.5 18.3 29.83 22.4 29.83C26.5 29.83 29.83 26.5 29.83 22.4C29.83 18.3 26.5 14.97 22.4 14.97ZM12 22.4C12 16.66 16.66 12 22.4 12C28.14 12 32.8 16.66 32.8 22.4C32.8 28.14 28.14 32.8 22.4 32.8C16.66 32.8 12 28.14 12 22.4Z" fill="#988200"/>
    <path d="M26.98 18.95C27.49 19.47 27.49 20.31 26.98 20.83L21.78 26.17C21.27 26.69 20.45 26.69 19.94 26.17L17.34 23.5C16.83 22.98 16.83 22.14 17.34 21.62C17.85 21.1 18.67 21.1 19.18 21.62L20.86 23.34L25.14 18.95C25.65 18.43 26.47 18.43 26.98 18.95Z" fill="#988200"/>
    <path d="M33.6 26.17C29.5 26.17 26.17 29.5 26.17 33.6C26.17 37.7 29.5 41.03 33.6 41.03C37.7 41.03 41.03 37.7 41.03 33.6C41.03 29.5 37.7 26.17 33.6 26.17ZM23.2 33.6C23.2 27.86 27.86 23.2 33.6 23.2C39.34 23.2 44 27.86 44 33.6C44 39.34 39.34 44 33.6 44C27.86 44 23.2 39.34 23.2 33.6Z" fill="#E5C300"/>
    <path d="M29.82 29.67C30.41 29.07 31.38 29.07 31.97 29.67L37.36 35.05C37.96 35.65 37.96 36.61 37.36 37.21C36.77 37.8 35.8 37.8 35.21 37.21L29.82 31.82C29.22 31.23 29.22 30.26 29.82 29.67Z" fill="#E5C300"/>
    <path d="M37.36 29.66C37.96 30.26 37.96 31.22 37.36 31.82L31.97 37.21C31.38 37.8 30.41 37.8 29.82 37.21C29.22 36.61 29.22 35.65 29.82 35.05L35.21 29.66C35.8 29.07 36.76 29.07 37.36 29.66Z" fill="#E5C300"/>
  </svg>
);

/* ─── Modern Donut Chart Component ─── */
const DonutChart = ({ segments = [], size = 145, strokeWidth = 22, totalCount = 0 }) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  let cumulativePercent = 0;

  const validSegments = segments.filter((s) => s.value > 0);
  const totalVal = validSegments.reduce((sum, s) => sum + s.value, 0);

  return (
    <div className="scorecard-donut-wrapper">
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} className="scorecard-donut-chart">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="#f1f5f9"
          strokeWidth={strokeWidth}
        />
        {validSegments.map((seg, i) => {
          const normalizedVal = totalVal > 0 ? (seg.value / totalVal) * 100 : seg.value;
          const dashLength = (normalizedVal / 100) * circumference;
          const gapLength = validSegments.length > 1 ? 3 : 0;
          const effectiveDash = Math.max(dashLength - gapLength, 1);
          const dashOffset = -((cumulativePercent / 100) * circumference);
          cumulativePercent += normalizedVal;

          return (
            <circle
              key={i}
              cx={size / 2}
              cy={size / 2}
              r={radius}
              fill="none"
              stroke={seg.color}
              strokeWidth={strokeWidth}
              strokeDasharray={`${effectiveDash} ${circumference - effectiveDash}`}
              strokeDashoffset={dashOffset}
              transform={`rotate(-90 ${size / 2} ${size / 2})`}
              className="scorecard-donut-segment"
            />
          );
        })}
        {/* Center cutout */}
        <circle cx={size / 2} cy={size / 2} r={Math.max(radius - strokeWidth / 2 - 2, 0)} fill="#ffffff" />
        <text
          x={size / 2}
          y={size / 2 - 5}
          textAnchor="middle"
          dominantBaseline="central"
          className="scorecard-donut-center-num"
        >
          {totalCount || validSegments.length}
        </text>
        <text
          x={size / 2}
          y={size / 2 + 13}
          textAnchor="middle"
          dominantBaseline="central"
          className="scorecard-donut-center-label"
        >
          {totalCount ? "QUESTIONS" : "TOPICS"}
        </text>
      </svg>
    </div>
  );
};

/* ─── Modern Speed Gauge Component ─── */
const SpeedGauge = ({ value = 0, maxValue = 120, width = 210 }) => {
  const clamped = Math.max(0, Math.min(value, maxValue));
  const cx = width / 2;
  const cy = 90;
  const radius = 68;
  const strokeWidth = 12;

  const polarToCartesian = (centerX, centerY, r, angleInDegrees) => {
    const angleInRadians = ((angleInDegrees - 180) * Math.PI) / 180.0;
    return {
      x: centerX + r * Math.cos(angleInRadians),
      y: centerY + r * Math.sin(angleInRadians),
    };
  };

  const describeArc = (x, y, r, startAngle, endAngle) => {
    const start = polarToCartesian(x, y, r, endAngle);
    const end = polarToCartesian(x, y, r, startAngle);
    const arcSweep = endAngle - startAngle <= 180 ? "0" : "1";
    return [
      "M", start.x, start.y,
      "A", r, r, 0, arcSweep, 0, end.x, end.y
    ].join(" ");
  };

  let activeZone = "Fast";
  let activeColor = "#10b981";
  if (value >= 40 && value <= 60) {
    activeZone = "Ideal";
    activeColor = "#3b82f6";
  } else if (value > 60) {
    activeZone = "Slow";
    activeColor = "#f43f5e";
  }

  const indicatorAngle = (clamped / maxValue) * 180;
  const indicatorPos = polarToCartesian(cx, cy, radius, indicatorAngle);

  return (
    <div className="scorecard-speed-gauge-wrap">
      <svg width={width} height={105} viewBox={`0 0 ${width} 105`} className="scorecard-gauge-svg">
        <defs>
          <linearGradient id="speedGrad" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#10b981" />
            <stop offset="33%" stopColor="#10b981" />
            <stop offset="48%" stopColor="#3b82f6" />
            <stop offset="55%" stopColor="#3b82f6" />
            <stop offset="70%" stopColor="#f43f5e" />
            <stop offset="100%" stopColor="#f43f5e" />
          </linearGradient>
          <filter id="gaugeGlow" x="-30%" y="-30%" width="160%" height="160%">
            <feDropShadow dx="0" dy="1" stdDeviation="2" floodColor="#0f172a" floodOpacity="0.25" />
          </filter>
        </defs>

        {/* Soft background track */}
        <path
          d={describeArc(cx, cy, radius, 0, 180)}
          stroke="#f1f5f9"
          strokeWidth={strokeWidth}
          fill="none"
          strokeLinecap="round"
        />

        {/* Continuous gradient arc */}
        <path
          d={describeArc(cx, cy, radius, 0, 180)}
          stroke="url(#speedGrad)"
          strokeWidth={strokeWidth}
          fill="none"
          strokeLinecap="round"
        />

        {/* Dynamic Indicator Dot */}
        <circle
          cx={indicatorPos.x}
          cy={indicatorPos.y}
          r={7.5}
          fill="#ffffff"
          stroke={activeColor}
          strokeWidth={3.5}
          filter="url(#gaugeGlow)"
          className="scorecard-gauge-indicator"
        />

        {/* Big centered speed number */}
        <text x={cx} y={cy - 12} textAnchor="middle" dominantBaseline="central" className="scorecard-gauge-main-val">
          {Math.round(value)}
        </text>
        <text x={cx} y={cy + 7} textAnchor="middle" dominantBaseline="central" className="scorecard-gauge-sub-val">
          sec / qn
        </text>
      </svg>

      {/* Modern Status Pills */}
      <div className="scorecard-gauge-pills">
        <span className={`scorecard-gauge-pill fast-pill ${activeZone === "Fast" ? "active" : ""}`}>
          <span className="gauge-pill-dot green" /> Fast (&lt;40s)
        </span>
        <span className={`scorecard-gauge-pill ideal-pill ${activeZone === "Ideal" ? "active" : ""}`}>
          <span className="gauge-pill-dot blue" /> Ideal (40-60s)
        </span>
        <span className={`scorecard-gauge-pill slow-pill ${activeZone === "Slow" ? "active" : ""}`}>
          <span className="gauge-pill-dot red" /> Slow (&gt;60s)
        </span>
      </div>
    </div>
  );
};

/* ─── Scalable Strategy Scale Graphic ─── */
const AttemptScaleGraphic = () => (
  <svg width="100%" height="76" viewBox="0 0 250 76" fill="none" className="scorecard-scale-svg">
    <defs>
      <linearGradient id="curveGrad" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#3b82f6" stopOpacity="0.18" />
        <stop offset="100%" stopColor="#3b82f6" stopOpacity="0.0" />
      </linearGradient>
    </defs>
    
    {/* Grid / baseline */}
    <line x1="28" y1="58" x2="225" y2="58" stroke="#e2e8f0" strokeWidth="1" strokeDasharray="3 3" />
    <line x1="28" y1="14" x2="28" y2="58" stroke="#e2e8f0" strokeWidth="1" strokeDasharray="3 3" />

    {/* Area fill under curve */}
    <path
      d="M 30,20 C 75,32 135,48 224,55 L 224,58 L 30,58 Z"
      fill="url(#curveGrad)"
    />

    {/* Trade-off Curve */}
    <path
      d="M 30,20 C 75,32 135,48 224,55"
      stroke="#2563eb"
      strokeWidth="2.5"
      strokeLinecap="round"
    />

    {/* Sweet Spot Highlight Zone */}
    <rect x="114" y="14" width="96" height="20" rx="10" fill="#eff6ff" stroke="#bfdbfe" strokeWidth="1" />
    <text x="162" y="27" textAnchor="middle" fontSize="9.5" fontWeight="700" fill="#1d4ed8">
      Target: 75–85 Qs 🎯
    </text>

    {/* Marker Dot on curve */}
    <circle cx="162" cy="48" r="4.5" fill="#2563eb" stroke="#ffffff" strokeWidth="2" />

    {/* Axis labels */}
    <text x="28" y="10" fontSize="8.5" fontWeight="600" fill="#94a3b8">Accuracy</text>
    <text x="225" y="68" textAnchor="end" fontSize="8.5" fontWeight="600" fill="#94a3b8">Attempts →</text>
  </svg>
);

/* ─── Main ScoreCard Component ─── */
const positiveish = (value) => {
  return String(value).trim().toLowerCase() === "passed" ||
    String(value).trim().toLowerCase() === "pass" ||
    String(value).trim().toLowerCase() === "true" ||
    String(value).trim() === "1";
};

const getVal = (source, ...paths) => {
  if (!source || typeof source !== "object") return undefined;
  for (const path of paths) {
    const keys = path.split(".");
    let node = source;
    let found = true;
    for (const key of keys) {
      if (node && typeof node === "object" && key in node) {
        node = node[key];
      } else {
        found = false;
        break;
      }
    }
    if (found && node !== undefined && node !== null && node !== "") {
      return node;
    }
  }
  return undefined;
};

// by sudz - 260926 - Format name to Title Case (e.g., Sudhansu instead of SUDHANSU)
const formatUserName = (name) => {
  if (!name || typeof name !== "string") return "Candidate";
  return name
    .trim()
    .split(/\s+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

// by sudz - 260926 - Format marks to 3 decimal places
const formatMarks = (val, decimals = 3) => {
  if (val === null || val === undefined || val === "" || val === "N/A" || val === "—") {
    return val ?? "—";
  }
  const num = Number(val);
  if (isNaN(num)) return val;
  return num.toFixed(decimals);
};

const ScoreCard = ({ userName = "debadarsi", questions = [], answers = {}, guessTypes = {}, avgSpeed = 0, testName = "", scorecardData = null }) => {
  const [economyExpanded, setEconomyExpanded] = useState(true);
  const [showRateModal, setShowRateModal] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const scorecardRef = useRef(null);

  const sc = scorecardData && typeof scorecardData === "object" ? scorecardData : {};
  const scSummary = getVal(sc, "summary", "scorecard", "result") || {};
  const summarySource = { ...scSummary, ...sc };
  const valFrom = (...paths) => getVal(summarySource, ...paths);

  const totalQuestions = valFrom("totalQuestions", "total", "num_questions", "questions") ?? (questions.length || 25);
  const totalMarks = valFrom("overall.total_marks", "totalMarks", "max_marks", "total_marks", "maximum_marks") ?? 0;
  const marksObtained = valFrom("overall.secured_marks", "marksObtained", "marks", "obtained_marks", "secured_marks", "scored_marks", "score", "total_score") ?? 0;
  const correctCount = valFrom("overall.correct_answers", "correct", "correct_count", "correct_answers", "num_correct") ?? 0;
  const wrongCount = valFrom("overall.wrong_answers", "wrong", "incorrect", "incorrect_count", "wrong_answers", "num_incorrect") ?? 0;
  const attempted = valFrom("overall.attempted_questions", "attempted", "attempted_count", "answered", "questions_attempted") ?? (correctCount + wrongCount);
  const percentile = valFrom("overall.percentage", "percentile") ?? "N/A";
  const speedSource = valFrom("speed") || {};
  const speedValue =
    getVal(
      speedSource,
      "avg_time_per_question_all",
      "avg_time_per_attempted"
    ) ?? valFrom("avgSpeed", "average_speed") ?? avgSpeed;
  const attemptPctVal = valFrom("attemptPercent", "attempt_percentage", "attempt_pct", "overall.attempt_pct", "attempt") ?? 0;
  const accuracyVal = valFrom("accuracy", "accuracyPercent", "accuracy_percentage", "overall.attempt_accuracy_pct", "attempt_accuracy_pct") ?? 0;
  const passed = valFrom("passed", "is_passed", "status") ?? null;
  const rank = valFrom("overall.rank", "rank", "rank_global") ?? "N/A";
  const topperMarks = valFrom("overall.toppers_marks", "topperMarks", "topper_marks", "highest_marks") ?? "N/A";
  const cutoffMarks = valFrom("overall.cutoff_marks", "cutoffMarks", "cutoff_marks") ?? null;

  const unattemptedMarks = valFrom("unattemptedMarks", "overall.unattempted_marks", "unattempted_marks", "not_attempted_marks") ?? "N/A";
  const unattemptedQuestions = valFrom("unattemptedQuestions", "unattempted_questions", "unattempted_count", "not_attempted") ?? Math.max(totalQuestions - attempted, 0);
  const positiveMarks = valFrom("positiveMarks", "overall.positive_marks", "positive_marks", "positive") ?? marksObtained;
  const negativeMarks = valFrom("negativeMarks", "overall.negative_marks", "negative_marks", "neg_marks") ?? "N/A";
  const correctAnswers = correctCount;
  const incorrectAnswers = wrongCount;

  const statsGridRows = [
    { label1: "Percentile", value1: percentile, label2: "Questions Answered", value2: `${attempted}/${totalQuestions}` },
    { label1: "Unattempted Marks", value1: formatMarks(unattemptedMarks), label2: "Unattempted Questions", value2: unattemptedQuestions },
    { label1: "Positive Marks", value1: formatMarks(positiveMarks), label2: "Correct Answers", value2: correctAnswers },
    { label1: "Negative Marks", value1: formatMarks(negativeMarks), label2: "Incorrect Answers", value2: incorrectAnswers },
  ];

  const calculatedAttemptPct = totalQuestions > 0 ? Math.round((attempted / totalQuestions) * 100) : 0;
  const maxAttemptPct = typeof attemptPctVal === "number" && attemptPctVal > 0 ? attemptPctVal : (Number(attemptPctVal) || calculatedAttemptPct);
  const calculatedAccuracyPct = attempted > 0 ? Math.round((correctCount / attempted) * 100) : 0;
  const maxAccuracy = typeof accuracyVal === "number" && accuracyVal > 0 ? accuracyVal : (Number(accuracyVal) || calculatedAccuracyPct);

  const passedStr = passed === null || passed === undefined ? null : String(passed);
  let passedBadge = null;
  if (passedStr && positiveish(passedStr)) {
    passedBadge = "Passed";
  } else if (passedStr && !positiveish(passedStr)) {
    passedBadge = "Failed";
  } else if (cutoffMarks !== null && cutoffMarks !== undefined && typeof marksObtained === "number") {
    passedBadge = marksObtained >= Number(cutoffMarks) ? "Passed" : "Failed";
  }

  /* -- Data -- */
  const baseLabels = [
    { label: "Money Market and Capital Market in India - Instruments and Dynamics", color: "#3b82f6" },
    { label: "Banking System in India", color: "#dc2626" },
    { label: "Economic Growth and its Measures", color: "#eab308" },
    { label: "Stock Market", color: "#10b981" },
    { label: "Inflation - Concepts, Facts and Policy", color: "#a855f7" },
    { label: "Taxation", color: "#06b6d4" },
    { label: "Fiscal Policy", color: "#f97316" },
    { label: "Economic Inequality", color: "#84cc16" },
    { label: "Employment, Skills and Labour in India", color: "#4f46e5" },
    { label: "Others (Pink)", color: "#ec4899" },
    { label: "Others (Teal)", color: "#0f766e" },
    { label: "Others (Rose)", color: "#db2777" },
  ];

  const counts = Array(12).fill(0);
  if (questions.length === 0) {
    const defaultValues = [4, 12, 20, 4, 24, 4, 8, 4, 8, 4, 4, 4];
    defaultValues.forEach((val, i) => { counts[i] = val; });
  } else {
    questions.forEach((_, idx) => {
      counts[idx % 12]++;
    });
    counts.forEach((c, i) => {
      counts[i] = Math.round((c / totalQuestions) * 100);
    });
  }

  const paletteColors = [
    "#3b82f6", "#dc2626", "#eab308", "#10b981", "#a855f7", "#06b6d4",
    "#f97316", "#84cc16", "#4f46e5", "#ec4899", "#0f766e", "#db2777",
  ];

  const rawTopicWise = valFrom("topic_wise", "topicWise") || [];

  const compositionSegments =
    rawTopicWise.length > 0
      ? rawTopicWise.map((t, i) => ({
          label: t.topic || "Topic",
          value:
            Number(t.question_share_pct ?? t.questionSharePct ?? 0) || 0,
          color: paletteColors[i % paletteColors.length],
        }))
      : baseLabels.map((lbl, i) => ({
          ...lbl,
          value: counts[i],
        }));

  const levelWiseData = valFrom("level_wise", "levelWise") || [];

  const topicWiseData = valFrom("topic_wise", "topicWise") || [];

  const levelDotColor = (level) => {
    const l = String(level || "").toLowerCase();
    if (l.includes("easy")) return "green";
    if (l.includes("medium") || l.includes("moderate")) return "orange";
    if (l.includes("hard") || l.includes("difficult") || l.includes("tough")) return "red";
    return "green";
  };

  const defaultLevels = [
    { level: "Easy", dot: "green" },
    { level: "Medium", dot: "orange" },
    { level: "Hard", dot: "red" },
  ];

  const cvaData = defaultLevels.map((d) => {
    const matches = levelWiseData.filter(
      (l) => levelDotColor(l.level) === d.dot
    );
    const sum = (key, sub) =>
      matches.reduce(
        (s, l) => s + (sub ? l[key]?.[sub] ?? 0 : l[key] ?? 0),
        0
      );
    const questions = sum("total_questions");
    const attempted = matches.reduce(
      (s, l) =>
        s + (l.attempted ?? (l.correct_answers ?? 0) + (l.incorrect_answers ?? 0)),
      0
    );
    return {
      level: d.level,
      dot: d.dot,
      questions,
      unattempted: matches.reduce(
        (s, l) =>
          s +
          (l.unattempted ??
            Math.max((l.total_questions ?? 0) - (l.attempted ?? 0), 0)),
        0
      ),
      correct: sum("correct_answers"),
      wrong: sum("incorrect_answers"),
      marks: sum("marks_obtained"),
      attempted,
      confident: sum("confident", "correct") + sum("confident", "incorrect"),
      confidentCorrect: sum("confident", "correct"),
      confidentIncorrect: sum("confident", "incorrect"),
      smart: sum("smart_guess", "correct") + sum("smart_guess", "incorrect"),
      smartCorrect: sum("smart_guess", "correct"),
      smartIncorrect: sum("smart_guess", "incorrect"),
      blind: sum("blind_guess", "correct") + sum("blind_guess", "incorrect"),
      blindCorrect: sum("blind_guess", "correct"),
      blindIncorrect: sum("blind_guess", "incorrect"),
    };
  });

  const cvaTotals = cvaData.reduce(
    (a, r) => {
      a.attempted += r.attempted || 0;
      a.confident += r.confident || 0;
      a.confidentCorrect += r.confidentCorrect || 0;
      a.confidentIncorrect += r.confidentIncorrect || 0;
      a.smart += r.smart || 0;
      a.smartCorrect += r.smartCorrect || 0;
      a.smartIncorrect += r.smartIncorrect || 0;
      a.blind += r.blind || 0;
      a.blindCorrect += r.blindCorrect || 0;
      a.blindIncorrect += r.blindIncorrect || 0;
      return a;
    },
    { attempted: 0, confident: 0, confidentCorrect: 0, confidentIncorrect: 0, smart: 0, smartCorrect: 0, smartIncorrect: 0, blind: 0, blindCorrect: 0, blindIncorrect: 0 }
  );

  const formatTime = (seconds) => {
    const secs = Number(seconds) || 0;
    if (secs < 60) return `${secs} sec`;
    const min = Math.floor(secs / 60);
    const rem = secs % 60;
    return rem ? `${min} min ${rem} sec` : `${min} min`;
  };

  const topicTotals = topicWiseData.reduce(
    (acc, t) => {
      const corr = t.correct_answers ?? 0;
      const inc = t.incorrect_answers ?? 0;
      acc.totalQuestions += t.total_questions ?? 0;
      acc.correct += corr;
      acc.incorrect += inc;
      acc.marks += t.marks_obtained ?? 0;
      acc.time += t.time_taken_seconds ?? 0;
      acc.attempted += corr + inc;
      return acc;
    },
    { totalQuestions: 0, correct: 0, incorrect: 0, marks: 0, time: 0, attempted: 0 }
  );
  const topicAverageAccuracy =
    topicWiseData.length > 0
      ? topicWiseData.reduce((s, t) => s + (Number(t.accuracy_pct) || 0), 0) / topicWiseData.length
      : 0;

  const levelRemarks = (level, attempted, total) =>
    attempted === 0
      ? `It appears that you did not answer any ${level} questions.`
      : `You answered ${attempted}/${total} ${level} questions.`;

  const levelDescription = (level) => {
    if (level === "Easy") return "Your understanding of basic concepts needs improvement, which is impacting your confidence and performance. Let's concentrate on building a solid foundation.";
    if (level === "Medium") return "Strengthen your foundation by concentrating on essential concepts for better preparation.";
    if (level === "Hard") return "Dive into your studies with curiosity and explore the areas where you feel there's room for more knowledge.";
    return "Keep practicing to improve your performance.";
  };

  // by sudz - 260926 - Scorecard PDF download layout and page-break optimization (prevents 2nd layer cutoff)
  const handleDownloadPdf = async () => {
    const element = scorecardRef.current;
    if (!element || downloading) return;

    setDownloading(true);

    const toBase64 = async (url) => {
      const res = await fetch(url);
      const blob = await res.blob();
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
    };

    let clonedElement = element.cloneNode(true);
    let wrapper;
    let styleEl;

    try {
      clonedElement.querySelectorAll(".scorecard-download-btn").forEach((el) => el.remove());

      const inlineImages = clonedElement.querySelectorAll("img");
      for (const img of inlineImages) {
        const src = img.src;
        if (src && !src.startsWith("data:") && !src.startsWith("blob:")) {
          try {
            const base64Data = await toBase64(src);
            img.src = base64Data;
          } catch (err) {
            console.warn("Failed to convert inline image to base64, setting crossorigin:", src, err);
            img.setAttribute("crossorigin", "anonymous");
          }
        }
      }

      wrapper = document.createElement("div");
      wrapper.style.position = "relative";
      wrapper.appendChild(clonedElement);

      const style = document.createElement("style");
      style.innerHTML = `
        .scorecard-box {
          padding: 2px 12px 4px 12px !important;
        }
        .scorecard-results-heading {
          font-size: 13px !important;
          margin-bottom: 3px !important;
        }
        .scorecard-greeting {
          margin-bottom: 4px !important;
        }
        .scorecard-greeting h1 {
          font-size: 14.5px !important;
          margin-bottom: 1px !important;
        }
        .scorecard-greeting span {
          font-size: 10px !important;
          line-height: 1.25 !important;
        }
        .scorecard-stats-container {
          margin-bottom: 6px !important;
          padding: 6px 10px !important;
          page-break-inside: avoid !important;
          break-inside: avoid !important;
        }
        .scorecard-rank-row {
          gap: 6px !important;
          margin-bottom: 5px !important;
        }
        .scorecard-stat-card {
          padding: 4px 8px !important;
        }
        .scorecard-stat-card svg {
          width: 14px !important;
          height: 14px !important;
        }
        .scorecard-stat-labels span:first-child {
          font-size: 9.5px !important;
        }
        .scorecard-stat-labels span:last-child {
          font-size: 13px !important;
        }
        .scorecard-stats-grid {
          gap: 3px !important;
        }
        .scorecard-stat-pair {
          padding: 1px 0 !important;
        }
        .scorecard-stat-pair span:first-child {
          font-size: 9.5px !important;
        }
        .scorecard-stat-pair span:last-child {
          font-size: 11px !important;
        }
        .scorecard-analytics-row {
          display: grid !important;
          grid-template-columns: repeat(2, 1fr) !important;
          gap: 10px !important;
          margin-bottom: 4px !important;
          page-break-inside: avoid !important;
          break-inside: avoid !important;
        }
        .scorecard-composition-card {
          grid-column: 1 / -1 !important;
        }
        .scorecard-composition-body {
          display: flex !important;
          align-items: center !important;
          gap: 20px !important;
          padding: 2px 0 4px 0 !important;
        }
        .scorecard-composition-legend {
          display: grid !important;
          grid-template-columns: repeat(2, 1fr) !important;
          gap: 3px 16px !important;
          flex: 1 !important;
        }
        .scorecard-analytics-card {
          padding: 6px 8px !important;
          page-break-inside: avoid !important;
          break-inside: avoid !important;
        }
        .scorecard-analytics-card-header {
          margin-bottom: 3px !important;
        }
        .scorecard-analytics-card-title {
          font-size: 11px !important;
        }
        .scorecard-speed-body {
          padding: 2px 0 4px 0 !important;
        }
        .scorecard-donut-wrapper svg {
          width: 95px !important;
          height: 95px !important;
        }
        .scorecard-scale-svg {
          height: 58px !important;
        }
        .scorecard-speed-body svg {
          height: 75px !important;
        }
        .scorecard-gauge-pills {
          margin-top: 2px !important;
          gap: 4px !important;
        }
        .scorecard-gauge-pill {
          font-size: 8.5px !important;
          padding: 1px 4px !important;
        }
        .scorecard-card-footer-box {
          margin-top: 4px !important;
          padding: 4px 6px !important;
        }
        .scorecard-card-footer-box p {
          font-size: 9px !important;
          line-height: 1.25 !important;
        }
        .scorecard-complexity-section {
          page-break-before: always !important;
          break-before: page !important;
          padding-top: 14px !important;
        }
        .scorecard-complexity-cards {
          page-break-inside: avoid !important;
          break-inside: avoid !important;
        }
        .scorecard-module-section {
          margin-bottom: 0 !important;
          padding-bottom: 0 !important;
        }
        .scorecard-module-table-wrap {
          margin-bottom: 0 !important;
        }
        .scorecard-cva-section {
          page-break-inside: avoid !important;
          break-inside: avoid !important;
          padding-top: 14px !important;
        }
        .scorecard-cva-table-wrap {
          page-break-inside: avoid !important;
          break-inside: avoid !important;
        }
        .scorecard-bottom-note {
          page-break-inside: avoid !important;
          break-inside: avoid !important;
          margin-top: 10px !important;
        }
        thead {
          display: table-header-group !important;
        }
        table {
          width: 100% !important;
          page-break-inside: auto !important;
          margin-top: 6px !important;
          margin-bottom: 2px !important;
        }
        tr {
          page-break-inside: avoid !important;
          break-inside: avoid !important;
        }
      `;
      styleEl = style;
      document.head.appendChild(style);

      const fileName = `scorecard-${(testName || "results").replace(/[^a-z0-9]+/gi, "-").toLowerCase()}.pdf`;

      const opt = {
        margin: [0.72, 0.35, 0.80, 0.35],
        filename: fileName,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: {
          scale: 2,
          useCORS: true,
          logging: false,
        },
        jsPDF: {
          unit: "in",
          format: "letter",
          orientation: "portrait",
        },
        pagebreak: { mode: ["css", "legacy"] },
      };

      document.body.appendChild(wrapper);

      // by sudz - 260926 - Prevent blank page in PDF by conditionally breaking before CVA section only if preceding content shares the page
      const cvaEl = wrapper.querySelector(".scorecard-cva-section");
      if (cvaEl) {
        const wrapperRect = wrapper.getBoundingClientRect();
        const cvaRect = cvaEl.getBoundingClientRect();
        const relativeTop = cvaRect.top - wrapperRect.top;
        const pxPageHeight = (11.0 - 0.72 - 0.80) * 96; // 910.08px printable inner height
        const offsetInPage = relativeTop % pxPageHeight;
        if (offsetInPage >= 80) {
          cvaEl.style.setProperty("page-break-before", "always", "important");
          cvaEl.style.setProperty("break-before", "page", "important");
        }
      }

      await html2pdf()
        .set(opt)
        .from(wrapper)
        .toPdf()
        .get("pdf")
        .then(async (pdf) => {
          const totalPages = pdf.internal.getNumberOfPages();
          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();

          await decoratePdf({
            pdf,
            headerLogo: pdfHeaderLogo,
            watermark: watermarkImage,
            totalPages,
            pageWidth,
            pageHeight,
          });

          pdf.save(fileName);
        });
    } catch (err) {
      console.error("PDF generation failed:", err);
    } finally {
      if (wrapper && wrapper.parentNode) {
        try {
          wrapper.parentNode.removeChild(wrapper);
        } catch (e) {}
      }
      if (styleEl && styleEl.parentNode) {
        try {
          styleEl.parentNode.removeChild(styleEl);
        } catch (e) {}
      }
      setDownloading(false);
    }
  };

  return (
    <div className="scorecard-box" ref={scorecardRef}>

      {/* ── Top Bar ── */}
      <div className="scorecard-top-bar">
        <div className="scorecard-select">{testName}</div>
        <button
          type="button"
          className="scorecard-download-btn"
          onClick={handleDownloadPdf}
          disabled={downloading}
        >
          {downloading ? "Please wait..." : "⬇ Download PDF"}
        </button>
      </div>

      <hr className="scorecard-hr" />

      {/* ── Title ── */}
      <div className="scorecard-results-heading">
        {testName ? `Your Results for the Test - ${testName}` : "Your Results for the Test"}
      </div>

      {/* ── Greeting ── */}
      <div className="scorecard-greeting">
        <h1 className="scorecard-user-name">Hi {formatUserName(userName)},</h1>
        <span className="scorecard-user-email">
          Congratulations on completing this test. Here, you can find detailed insights on your performance based on the difficulty level of test and the way you attempted each question.
        </span>
      </div>

      {/* ── Stats Container ── */}
      <div className="scorecard-stats-container">
        {/* Top row: 4 stat cards */}
        <div className="scorecard-rank-row">
          {/* Rank */}
          <div className="scorecard-stat-card">
            <div className="scorecard-stat-icon purple"><RankIcon /></div>
            <div className="scorecard-stat-labels">
              <span className="scorecard-stat-label">Rank</span>
              <span className="scorecard-stat-value">{rank}</span>
            </div>
          </div>
          {/* Total Marks */}
          <div className="scorecard-stat-card">
            <div className="scorecard-stat-icon green"><CheckIcon /></div>
            <div className="scorecard-stat-labels">
              <span className="scorecard-stat-label">Your marks</span>
              <div className="scorecard-stat-value-row">
                <span className="scorecard-stat-value">{formatMarks(marksObtained)}/{formatMarks(totalMarks)}</span>
                {passedBadge && (
                  <span className={`scorecard-stat-badge ${passedBadge === "Passed" ? "green-badge" : "red-badge"}`}>{passedBadge}</span>
                )}
              </div>
            </div>
          </div>
          {/* Cutoff Marks */}
          <div className="scorecard-stat-card">
            <div className="scorecard-stat-icon blue"><TargetIcon /></div>
            <div className="scorecard-stat-labels">
              <span className="scorecard-stat-label">Cutoff Marks</span>
              <span className="scorecard-stat-value">{formatMarks(cutoffMarks)}</span>
            </div>
          </div>
          {/* Topper Marks */}
          <div className="scorecard-stat-card">
            <div className="scorecard-stat-icon yellow"><StarIcon /></div>
            <div className="scorecard-stat-labels">
              <span className="scorecard-stat-label">Topper Marks</span>
              <span className="scorecard-stat-value">{formatMarks(topperMarks)}</span>
            </div>
          </div>
        </div>

        {/* Bottom stat values */}
        <div className="scorecard-stats-grid">
          {statsGridRows.map((row, i) => (
            <div className="scorecard-stat-col" key={i}>
              <div className="scorecard-stat-pair">
                <span className="scorecard-stat-pair-label">{row.label1}</span>
                <span className="scorecard-stat-pair-value">{row.value1}</span>
              </div>
              <div className="scorecard-stat-pair">
                <span className="scorecard-stat-pair-label">{row.label2}</span>
                <span className="scorecard-stat-pair-value">{row.value2}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ── Modern 3-Card Analytics Row: 1. Paper Composition | 2. Attempt | 3. Speed ── */}
      <div className="scorecard-analytics-row">
        {/* 1st: Paper Composition */}
        <div className="scorecard-analytics-card scorecard-composition-card">
          <div className="scorecard-card-header">
            <div className="scorecard-card-title-wrap">
              <span className="scorecard-card-icon blue-tint">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>
              </span>
              <span className="scorecard-card-title">Paper Composition</span>
            </div>
            <span className="scorecard-card-badge">{compositionSegments.length} Topics</span>
          </div>

          <div className="scorecard-composition-body">
            <DonutChart segments={compositionSegments} size={145} strokeWidth={22} totalCount={totalQuestions} />
            <div className="scorecard-composition-legend">
              {compositionSegments.slice(0, 8).map((seg, i) => (
                <div key={i} className="scorecard-composition-legend-item">
                  <span className="scorecard-legend-dot" style={{ backgroundColor: seg.color }} />
                  <span className="scorecard-legend-name" title={seg.label}>{seg.label}</span>
                  <span className="scorecard-legend-val">{seg.value}%</span>
                </div>
              ))}
            </div>
          </div>

          <div className="scorecard-card-footer-box blue-box">
            <div className="scorecard-footer-box-title">
              <span>📊</span> Syllabus Coverage
            </div>
            <p className="scorecard-footer-box-text">
              Distribution across {compositionSegments.length} key modules and topics.
            </p>
          </div>
        </div>

        {/* 2nd: Attempt */}
        <div className="scorecard-analytics-card scorecard-attempt-card">
          <div className="scorecard-card-header">
            <div className="scorecard-card-title-wrap">
              <span className="scorecard-card-icon amber-tint">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#d97706" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>
              </span>
              <span className="scorecard-card-title">Attempt Analysis</span>
            </div>
            <span className="scorecard-card-badge">{attempted}/{totalQuestions} Attempted</span>
          </div>

          <div className="scorecard-attempt-metrics-row">
            <div className="scorecard-attempt-stat-item">
              <div className="scorecard-stat-icon yellow">
                <AttemptCheckIcon />
              </div>
              <div className="scorecard-stat-labels">
                <span className="scorecard-stat-label">Attempt</span>
                <span className="scorecard-stat-value">{maxAttemptPct}%</span>
              </div>
            </div>
            <div className="scorecard-attempt-stat-item">
              <div className="scorecard-stat-icon green">
                <AttemptCheckIcon />
              </div>
              <div className="scorecard-stat-labels">
                <span className="scorecard-stat-label">Attempt Accuracy</span>
                <span className="scorecard-stat-value">{maxAccuracy}%</span>
              </div>
            </div>
          </div>

          <div className="scorecard-curve-visual-wrap">
            <AttemptScaleGraphic />
          </div>

          <div className="scorecard-card-footer-box green-box">
            <div className="scorecard-footer-box-title">
              <span>💡</span> Optimal Strategy
            </div>
            <p className="scorecard-footer-box-text">
              Higher attempts reduce required accuracy. Balance both for optimal scores.
            </p>
          </div>
        </div>

        {/* 3rd: Speed */}
        <div className="scorecard-analytics-card scorecard-speed-card">
          <div className="scorecard-card-header">
            <div className="scorecard-card-title-wrap">
              <span className="scorecard-card-icon cyan-tint">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#0284c7" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
              </span>
              <span className="scorecard-card-title">Speed Analysis</span>
            </div>
            <div className="scorecard-speed-badge">
              <img src="/assets/images/score_card_speed.svg" alt="speed" width="16" height="16" />
              <span>{Math.round(speedValue)} sec/qn</span>
            </div>
          </div>

          <div className="scorecard-speed-body">
            <SpeedGauge value={speedValue} maxValue={120} width={220} />
          </div>

          <div className="scorecard-card-footer-box amber-box">
            <div className="scorecard-footer-box-title">
              <span>⏱</span> Pace Guidance
            </div>
            <p className="scorecard-footer-box-text">
              Target 40–60s/question to ensure sufficient buffer for final revision.
            </p>
          </div>
        </div>
      </div>

      {/* ── Performance based on complexity ── */}
      <div className="scorecard-complexity-section">
        <div className="scorecard-complexity-header-row">
          <div className="scorecard-section-title">Performance based on complexity of questions</div>
          {/* <div className="scorecard-complexity-filter">
            All Modules <span className="filter-chevron">▼</span>
          </div> */}
        </div>
        
        
        <div className="scorecard-complexity-cards">
          {levelWiseData.length === 0 ? (
            <div className="scorecard-complexity-card">
              <div className="scorecard-complexity-description">No level-wise performance data available.</div>
            </div>
          ) : (
            levelWiseData.map((row, i) => (
              <div className="scorecard-complexity-card" key={i}>
                <div className="scorecard-complexity-stats-row">
                  <div className="scorecard-complexity-stat-col-left">
                    <div className="scorecard-complexity-stat-title">📊 {row.level} questions attempted:</div>
                    <div className="scorecard-complexity-stat-value">{row.attempted ?? 0}/{row.total_questions ?? 0}</div>
                  </div>
                  <div className="scorecard-complexity-stat-col-divider" />
                  <div className="scorecard-complexity-stat-col-right">
                    <div className="scorecard-complexity-stat-title">🎯 Attempt Accuracy:</div>
                    <div className="scorecard-complexity-stat-value">
                      {row.accuracy_pct ?? 0}% <span className="info-icon-gray">ℹ</span>
                    </div>
                  </div>
                </div>
                <div className="scorecard-complexity-remarks">
                  <div className="scorecard-remarks-lbl">Remarks:</div>
                  <div className="scorecard-remarks-text">{levelRemarks(row.level, row.attempted ?? 0, row.total_questions ?? 0)}</div>
                </div>
                <div className="scorecard-complexity-description">
                  {levelDescription(row.level)}
                </div>
              </div>
            ))
          )}
</div>
      </div>

      {/* ── Module Level Performance ── */}
      <div className="scorecard-module-section">
        <div className="scorecard-section-title">Module Level Performance</div>
        <div className="scorecard-module-table-wrap">
          <table className="scorecard-module-table">
            <thead>
              <tr>
                <th style={{ width: "16%" }}>Module</th>
                <th style={{ width: "24%" }}>Topic</th>
                <th className="scorecard-th-center" style={{ width: "12%" }}>Qn. Answered</th>
                <th className="scorecard-th-center" style={{ width: "9%" }}>Correct</th>
                <th className="scorecard-th-center" style={{ width: "9%" }}>Incorrect</th>
                <th className="scorecard-th-center" style={{ width: "9%" }}>Marks</th>
                <th className="scorecard-th-center" style={{ width: "11%" }}>Time Taken</th>
                <th className="scorecard-th-center" style={{ width: "10%" }}>Accuracy</th>
              </tr>
            </thead>
            <tbody>
              {topicWiseData.length === 0 ? (
                <tr className="scorecard-module-row-child">
                  <td colSpan={8} style={{ textAlign: "center", padding: "16px", color: "#94a3b8" }}>
                    No topic-wise data available
                  </td>
                </tr>
              ) : (
                <>
                  {/* Parent Row: All Modules / All Topics */}
                  <tr className="scorecard-module-row-parent">
                    <td className="scorecard-module-name-cell">
                      <span className="scorecard-module-tag">All Modules</span>
                    </td>
                    <td>
                      <button
                        className="scorecard-module-expand-btn"
                        onClick={() => setEconomyExpanded(!economyExpanded)}
                      >
                        <svg
                          className={`expand-arrow-svg ${economyExpanded ? "expanded" : ""}`}
                          width="12"
                          height="12"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <polyline points="9 18 15 12 9 6" />
                        </svg>
                        <strong>All Topics</strong>
                      </button>
                    </td>
                    <td className="scorecard-td-center font-semibold">{topicTotals.attempted}/{topicTotals.totalQuestions}</td>
                    <td className="scorecard-td-center font-semibold text-green">{topicTotals.correct}</td>
                    <td className="scorecard-td-center font-semibold text-red">{topicTotals.incorrect}</td>
                    <td className="scorecard-td-center font-semibold">{formatMarks(topicTotals.marks)}</td>
                    <td className="scorecard-td-center">
                      <span className="time-taken-span">⏱ {formatTime(topicTotals.time)}</span>
                    </td>
                    <td className="scorecard-td-center">
                      <span className="scorecard-accuracy-badge-pill">{Math.round(topicAverageAccuracy)}%</span>
                    </td>
                  </tr>

                  {/* Sub-Rows (Topics) */}
                  {economyExpanded && topicWiseData.map((topic, index) => (
                    <tr key={topic.topic_id ?? index} className="scorecard-module-row-child">
                       <td></td>
                      <td className="scorecard-subtopic-name">{topic.topic}</td>
                      <td className="scorecard-td-center">{(topic.correct_answers ?? 0) + (topic.incorrect_answers ?? 0)}/{topic.total_questions ?? 0}</td>
                      <td className="scorecard-td-center text-green">{topic.correct_answers ?? 0}</td>
                      <td className="scorecard-td-center text-red">{topic.incorrect_answers ?? 0}</td>
                      <td className="scorecard-td-center">{formatMarks(topic.marks_obtained ?? 0)}</td>
                      <td className="scorecard-td-center">
                        <span className="time-taken-span">⏱ {formatTime(topic.time_taken_seconds)}</span>
                      </td>
                      <td className="scorecard-td-center">
                        <span className="scorecard-accuracy-badge-pill">{topic.accuracy_pct ?? 0}%</span>
                      </td>
                    </tr>
                  ))}
                </>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* ── Complexity vs Attempt Analysis ── */}
      <div className="scorecard-cva-section">
        <div className="scorecard-section-title">Complexity vs Attempt analysis</div>
        <div className="scorecard-cva-table-wrap">
          <table className="scorecard-cva-table">
            <thead>
              <tr>
                <th style={{ width: "16%" }}>Difficulty</th>
                <th className="scorecard-th-center" style={{ width: "14%" }}>No. of Questions</th>
                <th className="scorecard-th-center" style={{ width: "22%" }}>Performance</th>
                <th className="scorecard-th-center" style={{ width: "12%" }}>Total Attempted</th>
                <th className="scorecard-th-center" style={{ width: "12%" }}>Confident</th>
                <th className="scorecard-th-center" style={{ width: "12%" }}>Smart Guess</th>
                <th className="scorecard-th-center" style={{ width: "12%" }}>Blind Guess</th>
              </tr>
            </thead>
            <tbody>
              {cvaData.map((row, i) => (
                <tr key={i}>
                  <td>
                    <div className="scorecard-cva-level-cell">
                      <span className={`scorecard-cva-complexity-dot ${row.dot}`} />
                      <span className="scorecard-cva-level-name">{row.level}</span>
                    </div>
                  </td>
                  <td className="scorecard-td-center font-medium">{row.questions}</td>
                  <td>
                    <div className="scorecard-cva-performance justify-center">
                      <span className="scorecard-cva-perf-item scorecard-cva-perf-correct" data-tooltip="Correctly Answered">
                        {row.correct}
                        <img src="/assets/images/score_card_correct.svg" alt="correct" />
                      </span>
                      <span className="scorecard-cva-perf-item scorecard-cva-perf-incorrect" data-tooltip="Incorrectly Answered">
                        {row.wrong}
                        <img src="/assets/images/score_card_wrong.svg" alt="incorrect" />
                      </span>
                      <span className="scorecard-cva-perf-item scorecard-cva-perf-unattempted" data-tooltip="Questions Unattempted">
                        {row.unattempted}
                        <img src="/assets/images/score_card_warnning.svg" alt="unattempted" />
                      </span>
                    </div>
                  </td>
                  <td className="scorecard-td-center font-medium">{row.attempted}</td>
                  <td>
                    <div className="scorecard-cva-performance justify-center">
                      <span className="scorecard-cva-perf-item">
                        {row.confidentCorrect}
                        <img src="/assets/images/score_card_correct.svg" alt="correct" />
                      </span>
                      <span className="scorecard-cva-perf-item">
                        {row.confidentIncorrect}
                        <img src="/assets/images/score_card_wrong.svg" alt="incorrect" />
                      </span>
                    </div>
                  </td>
                  <td>
                    <div className="scorecard-cva-performance justify-center">
                      <span className="scorecard-cva-perf-item">
                        {row.smartCorrect}
                        <img src="/assets/images/score_card_correct.svg" alt="correct" />
                      </span>
                      <span className="scorecard-cva-perf-item">
                        {row.smartIncorrect}
                        <img src="/assets/images/score_card_wrong.svg" alt="incorrect" />
                      </span>
                    </div>
                  </td>
                  <td>
                    <div className="scorecard-cva-performance justify-center">
                      <span className="scorecard-cva-perf-item">
                        {row.blindCorrect}
                        <img src="/assets/images/score_card_correct.svg" alt="correct" />
                      </span>
                      <span className="scorecard-cva-perf-item">
                        {row.blindIncorrect}
                        <img src="/assets/images/score_card_wrong.svg" alt="incorrect" />
                      </span>
                    </div>
                  </td>
                </tr>
              ))}
              <tr className="scorecard-cva-total-row">
                <td><strong>Total</strong></td>
                <td className="scorecard-td-center"><strong>{totalQuestions}</strong></td>
                <td>
                  <div className="scorecard-cva-performance justify-center">
                    <span className="scorecard-cva-perf-item scorecard-cva-perf-correct" data-tooltip="Correctly Answered">
                      <strong>{correctCount}</strong>
                      <img src="/assets/images/score_card_correct.svg" alt="correct" />
                    </span>
                    <span className="scorecard-cva-perf-item scorecard-cva-perf-incorrect" data-tooltip="Incorrectly Answered">
                      <strong>{wrongCount}</strong>
                      <img src="/assets/images/score_card_wrong.svg" alt="incorrect" />
                    </span>
                    <span className="scorecard-cva-perf-item scorecard-cva-perf-unattempted" data-tooltip="Questions Unattempted">
                      <strong>{Math.max(totalQuestions - cvaTotals.attempted, 0)}</strong>
                      <img src="/assets/images/score_card_warnning.svg" alt="unattempted" />
                    </span>
                  </div>
                </td>
                <td className="scorecard-td-center"><strong>{cvaTotals.attempted}</strong></td>
                <td>
                  <div className="scorecard-cva-performance justify-center">
                    <span className="scorecard-cva-perf-item">
                      <strong>{cvaTotals.confidentCorrect}</strong>
                      <img src="/assets/images/score_card_correct.svg" alt="correct" />
                    </span>
                    <span className="scorecard-cva-perf-item">
                      <strong>{cvaTotals.confidentIncorrect}</strong>
                      <img src="/assets/images/score_card_wrong.svg" alt="incorrect" />
                    </span>
                  </div>
                </td>
                <td>
                  <div className="scorecard-cva-performance justify-center">
                    <span className="scorecard-cva-perf-item">
                      <strong>{cvaTotals.smartCorrect}</strong>
                      <img src="/assets/images/score_card_correct.svg" alt="correct" />
                    </span>
                    <span className="scorecard-cva-perf-item">
                      <strong>{cvaTotals.smartIncorrect}</strong>
                      <img src="/assets/images/score_card_wrong.svg" alt="incorrect" />
                    </span>
                  </div>
                </td>
                <td>
                  <div className="scorecard-cva-performance justify-center">
                    <span className="scorecard-cva-perf-item">
                      <strong>{cvaTotals.blindCorrect}</strong>
                      <img src="/assets/images/score_card_correct.svg" alt="correct" />
                    </span>
                    <span className="scorecard-cva-perf-item">
                      <strong>{cvaTotals.blindIncorrect}</strong>
                      <img src="/assets/images/score_card_wrong.svg" alt="incorrect" />
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* ── Bottom Note ── */}
      <div className="scorecard-bottom-note">
        <strong>Note:</strong> In order to receive detailed insights that will help your preparation, it is recommended that you make use of the "Attempt Analysis" feature and mark each question you answer as either confident, smart guess or blind guess. If you don't mark these options, the analysis we provide might not be relevant and useful for you.
      </div>

      {/* ── Rate Score Card Modal ── */}
      <RateScorecardModal
        open={showRateModal}
        onClose={() => setShowRateModal(false)}
      />
    </div>
  );
};

export default ScoreCard;
